import React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { SxProps } from "@mui/system";

interface NumberInputProps {
    defaultValue?: string | number;
    value?: string | number;
    size?: TextFieldProps["size"];
    label?: string;
    id?: string;
    className?: string;
    onChange?: (val: number | string) => void;
    endAdornment?: string;
    allowEmpty?: boolean;
    allowNegative?: boolean;
    allowDecimals?: boolean;
    sx?: SxProps;
    disabled?: boolean;
    fullWidth?: TextFieldProps["fullWidth"];
}

export const NumberInput = ({
    defaultValue,
    value,
    size,
    label,
    id,
    className = "",
    onChange,
    endAdornment,
    allowEmpty = false,
    allowNegative = false,
    allowDecimals = false,
    sx,
    disabled = false,
    fullWidth,
}: NumberInputProps) => {
    const handleChange = (val: string | number) => {
        if (onChange) {
            // Allow empty string
            onChange(val ? +val : val);
        }
    };

    return (
        <TextField
            id={id}
            size={size}
            type="number"
            value={value}
            defaultValue={defaultValue}
            className={className}
            label={label}
            onChange={(event) => handleChange(event.target.value)}
            onBlur={(event) => {
                let value = event.target.value;

                if (!allowEmpty) {
                    // If empty, change to 0 on blur
                    handleChange(value || 0);
                }

                if (!allowNegative && !!value) {
                    value = Math.max(+value, 0).toString();
                }

                if (!allowDecimals && !!value) {
                    value = parseInt(value).toString();
                }

                handleChange(value);
            }}
            InputProps={
                endAdornment
                    ? {
                        endAdornment: (
                            <InputAdornment position="end">
                                {endAdornment}
                            </InputAdornment>
                        ),
                    }
                    : null
            }
            sx={sx}
            disabled={disabled}
            fullWidth={fullWidth}
        />
    );
};
